import React, { useEffect, useState } from "react";
import "./header.css";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeNav, setActiveNav] = useState("#home");
  const [isScrolled, setIsScrolled] = useState(false);

  // Scroll shadow
  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY >= 80);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // ESC closes menu
  useEffect(() => {
    if (!isOpen) return;
    const onKeyDown = (e) => {
      if (e.key === "Escape") setIsOpen(false);
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [isOpen]);

  // Lock body scroll when menu open (mobile)
  useEffect(() => {
    if (!isOpen) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [isOpen]);

  const goTo = (hash) => {
    setActiveNav(hash);
    setIsOpen(false);
  };

  return (
    <header className={`header ${isScrolled ? "scroll-header" : ""}`}>
      <nav className="nav container">
        {/* Mobile + Desktop logo */}
        <a href="#home" className="navLogo" onClick={() => goTo("#home")}>
          OlgaCodes
        </a>

        {/* Desktop menu stays inline (CSS handles) */}
        <div className="navMenu navMenu--desktop">
          <ul className="navList">
            <li className="navItem">
              <a
                href="#home"
                onClick={() => goTo("#home")}
                className={activeNav === "#home" ? "navLink activeLink" : "navLink"}
              >
                Home
              </a>
            </li>
            <li className="navItem">
              <a
                href="#about"
                onClick={() => goTo("#about")}
                className={activeNav === "#about" ? "navLink activeLink" : "navLink"}
              >
                About
              </a>
            </li>
            <li className="navItem">
              <a
                href="#skills"
                onClick={() => goTo("#skills")}
                className={activeNav === "#skills" ? "navLink activeLink" : "navLink"}
              >
                Skills
              </a>
            </li>
            <li className="navItem">
              <a
                href="#services"
                onClick={() => goTo("#services")}
                className={activeNav === "#services" ? "navLink activeLink" : "navLink"}
              >
                Services
              </a>
            </li>
            <li className="navItem">
              <a
                href="#portfolio"
                onClick={() => goTo("#portfolio")}
                className={activeNav === "#portfolio" ? "navLink activeLink" : "navLink"}
              >
                Portfolio
              </a>
            </li>
            <li className="navItem">
              <a
                href="#contact"
                onClick={() => goTo("#contact")}
                className={activeNav === "#contact" ? "navLink activeLink" : "navLink"}
              >
                Contact
              </a>
            </li>
          </ul>
        </div>

        {/* MOBILE MENU BUTTON (only visible on mobile via CSS) */}
        <button
          className="navToggle"
          type="button"
          onClick={() => setIsOpen(true)}
          aria-label="Open menu"
        >
          <i className="uil uil-apps"></i>
        </button>
      </nav>

      {/* MOBILE OVERLAY MENU */}
      <div className={`mNav ${isOpen ? "mNav--open" : ""}`} aria-hidden={!isOpen}>
        <div className="mNav__backdrop" onClick={() => setIsOpen(false)} />

        <div className="mNav__panel" role="dialog" aria-modal="true">
          <div className="mNav__header">
            <div className="mNav__brand">
              <span className="mNav__logoDot" aria-hidden="true" />
              <span className="mNav__title">OlgaCodes</span>
            </div>

            <button
              className="mNav__close"
              type="button"
              onClick={() => setIsOpen(false)}
              aria-label="Close menu"
            >
              <i className="uil uil-times"></i>
            </button>
          </div>

          <ul className="mNav__list">
            <li>
              <a
                href="#home"
                onClick={() => goTo("#home")}
                className={activeNav === "#home" ? "mNav__link is-active" : "mNav__link"}
              >
                <i className="uil uil-estate"></i>
                <span>Home</span>
                <i className="uil uil-angle-right-b"></i>
              </a>
            </li>

            <li>
              <a
                href="#about"
                onClick={() => goTo("#about")}
                className={activeNav === "#about" ? "mNav__link is-active" : "mNav__link"}
              >
                <i className="uil uil-user"></i>
                <span>About</span>
                <i className="uil uil-angle-right-b"></i>
              </a>
            </li>

            <li>
              <a
                href="#skills"
                onClick={() => goTo("#skills")}
                className={activeNav === "#skills" ? "mNav__link is-active" : "mNav__link"}
              >
                <i className="uil uil-file-alt"></i>
                <span>Skills</span>
                <i className="uil uil-angle-right-b"></i>
              </a>
            </li>

            <li>
              <a
                href="#services"
                onClick={() => goTo("#services")}
                className={activeNav === "#services" ? "mNav__link is-active" : "mNav__link"}
              >
                <i className="uil uil-briefcase-alt"></i>
                <span>Services</span>
                <i className="uil uil-angle-right-b"></i>
              </a>
            </li>

            <li>
              <a
                href="#portfolio"
                onClick={() => goTo("#portfolio")}
                className={activeNav === "#portfolio" ? "mNav__link is-active" : "mNav__link"}
              >
                <i className="uil uil-scenery"></i>
                <span>Portfolio</span>
                <i className="uil uil-angle-right-b"></i>
              </a>
            </li>

            <li>
              <a
                href="#contact"
                onClick={() => goTo("#contact")}
                className={activeNav === "#contact" ? "mNav__link is-active" : "mNav__link"}
              >
                <i className="uil uil-message"></i>
                <span>Contact</span>
                <i className="uil uil-angle-right-b"></i>
              </a>
            </li>
          </ul>

          <div className="mNav__footer">
            <span className="mNav__hint">
              Tip: tap outside or press <kbd>ESC</kbd> to close
            </span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
